import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.FabricationJobItemFrameView.';
  public static readonly quotedTab = `${Id.prefix}quotedTab`;
  public static readonly onSiteMeasurementsHeader = `${Id.prefix}onSiteMeasurementsHeader`;
  public static readonly locationLabel = `${Id.prefix}locationLabel`;
  public static readonly descriptionLabel = `${Id.prefix}descriptionLabel`;
  public static readonly quantityLabel = `${Id.prefix}quantityLabel`;
  public static readonly propertiesHeader = `${Id.prefix}propertiesHeader`;
  public static readonly captureEditorStateFailed = `${Id.prefix}captureEditorStateFailed`;
  public static readonly saveUnitOverridesFailed = `${Id.prefix}saveUnitOverridesFailed`;
  public static readonly quotedMeasurementsHeader = `${Id.prefix}quotedMeasurementsHeader`;
}

export class LangFabricationJobItemFrameView {
  private constructor() {}
  public static quotedTab(): string {
    return interpolate(Id.quotedTab);
  }
  public static onSiteMeasurementsHeader(): string {
    return interpolate(Id.onSiteMeasurementsHeader);
  }
  public static locationLabel(): string {
    return interpolate(Id.locationLabel);
  }
  public static descriptionLabel(): string {
    return interpolate(Id.descriptionLabel);
  }
  public static quantityLabel(): string {
    return interpolate(Id.quantityLabel);
  }
  public static propertiesHeader(): string {
    return interpolate(Id.propertiesHeader);
  }
  public static captureEditorStateFailed(): string {
    return interpolate(Id.captureEditorStateFailed);
  }
  public static saveUnitOverridesFailed(): string {
    return interpolate(Id.saveUnitOverridesFailed);
  }
  public static quotedMeasurementsHeader(): string {
    return interpolate(Id.quotedMeasurementsHeader);
  }
}

export class FabricationJobItemFrameViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.quotedTab, 'Quoted', 'Tab label showing original quoted measurements');
    register.add(Id.onSiteMeasurementsHeader, 'On-site Measurements and Overrides for Individual Unit', 'Header for unit measurement override section');
    register.add(Id.locationLabel, 'Location', 'Form label for item location');
    register.add(Id.descriptionLabel, 'Description', 'Form label for item description');
    register.add(Id.quantityLabel, 'Quantity', 'Form label for item quantity');
    register.add(Id.propertiesHeader, 'Properties', 'Section header for item properties');
    register.add(Id.captureEditorStateFailed, 'Failed to capture editor changes', 'Error toast when V6 editor commit fails during tab switch');
    register.add(Id.saveUnitOverridesFailed, 'Failed to save unit overrides', 'Error toast when saving unit measurement overrides fails');
    register.add(Id.quotedMeasurementsHeader, 'Original Quoted Measurements', 'Header shown when viewing the original quoted measurements tab');
  }
}
